import { useAuthStore } from '../store';

/**
 * Hook to access auth state and actions
 */
export const useAuth = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const isLoading = useAuthStore((state) => state.isLoading);
  const login = useAuthStore((state) => state.login);
  const logout = useAuthStore((state) => state.logout);
  const user = useAuthStore((state) => state.user);

  return {
    isAuthenticated,
    isLoading,
    login,
    logout,
    user
  };
};
